// // eslint-disable-next-line
// import React, { useEffect } from 'react';
// import { get } from 'lodash';
// // eslint-disable-next-line
// import { Navigate, Route, useNavigate, useLocation } from "react-router-dom";
// import { getDefaultRoute } from '../utils/appUser'
// import appRoutes from './app.routes';
// import { useSelector, useDispatch } from "react-redux";
// import { rootReducersState } from '../reducers';

// const _ = { get };

// const RoutesContainer = ({ component: Component, layout: Layout, ...rest }: any) => {
// 	const navigate = useNavigate();
// 	// eslint-disable-next-line
// 	const dispatch = useDispatch();

// 	const sessionReducer = useSelector(({ session }: rootReducersState) => session);
// 	const loggedUser = _.get(sessionReducer, "currentUser", {});
// 	// eslint-disable-next-line
// 	const defaultRoute = getDefaultRoute();
// 	const token = _.get(sessionReducer, "token", null);

// 	const isPrivateRoute: boolean = _.get(rest, "private", false);
// 	const isLoggedIn: Boolean = token ? true : false;
// 	const accessLevel: string = _.get(rest, "access.level", "");

// 	const role = _.get(loggedUser, "role", "");
// const location = useLocation();

// 	// Do not allow each other users to access routes.
// 	if (isPrivateRoute && isLoggedIn) {

// 		// If current user has not access of route (company !== candidate)
// 		// Access Forbidden
// 		if (role !== accessLevel) {
// 			// return (<Redirect to={defaultRoute} />)
// 		}
// 	}

// 	return (
// 		<Route
// 			{...rest}
// 			render={props => {
// 				if (isPrivateRoute === true) {
// 					if (token) {
// 						// Redirect User to the relevant pages
// 						return (
// 							<Layout>
// 								<Component {...props} />
// 							</Layout>
// 						)
// 					} else {
// 						// redirect to login
// 						navigate(appRoutes.userLogin.path);
// 					}
// 				} else {
// 					// Check if user is already logged in
// 					// if (token && [appRoutes.userLogin.path, appRoutes.userSignUp.path].includes(history.location.pathname)) {
// 						if (token && [appRoutes.userLogin.path, appRoutes.userSignUp.path].includes(location.pathname)) {

// 						return (<Navigate to="/" />)
// 					} else {
// 						return (
// 							<Layout>
// 								<Component {...props} isPublic={true} />
// 							</Layout>
// 						)
// 					}
// 				}
// 			}
// 			}
// 		/>
// 	)
// }

// export default RoutesContainer;

// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import _ from "lodash";
// import { rootReducersState } from '../reducers';
// import { getDefaultRoute } from '../utils/appUser';
// import appRoutes from './app.routes';

// const RoutesContainer = ({
//   component: Component,
//   layout: Layout,
//   private: isPrivateRoute = false,
//   access = {},
//   ...rest
// }: any) => {
// 	console.log("RoutesContainer", { Component, Layout, isPrivateRoute, access, rest });
//   const location = useLocation();
//   const sessionReducer = useSelector(({ session }: rootReducersState) => session);
//   const loggedUser = _.get(sessionReducer, "currentUser", {});
//   console.log("loggedUser", loggedUser);
//   const token = _.get(sessionReducer, "token", null);
//   const isLoggedIn = !!token;
//   const accessLevel = access?.level || "";
//   const role = "candidate";
//   // _.get(loggedUser, "role", "");
// console.log("role", role);
//   if (isPrivateRoute) {
//     if (!isLoggedIn) {
//       console.log("User is not logged in, redirecting to login page");
//       return <Navigate to={appRoutes.userLogin.path} state={{ from: location }} replace />;
//     }
//     if (role !== accessLevel) {
//       console.log("Access forbidden: user role does not match required access level");
//       return <Navigate to={getDefaultRoute()} replace />;
//     }
//   } else {
//     if (
//       isLoggedIn &&
//       [appRoutes.userLogin.path, appRoutes.userSignUp.path].includes(location.pathname)
//     ) {
//       console.log("User is already logged in, redirecting to default route");
//       return <Navigate to={getDefaultRoute()} replace />;
//     }
//   }

//   if (Layout) {
//     console.log("Rendering component with layout");
//     return (
//       <Layout>
//         <Component {...rest} />
//       </Layout>
//     );
//   }
//   return <Component {...rest} />;
// };

// export default RoutesContainer;
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import { rootReducersState } from '../reducers';
import { getDefaultRoute } from '../utils/appUser';
import appRoutes from './app.routes';
import { isSessionMessagingEnabled } from '../utils/messaging.utils';

const RoutesContainer = ({
  component: Component,
  layout: Layout,
  private: isPrivateRoute = false,
  access = {},
  ...rest
}: any) => {
  // console.log("RoutesContainer", { Component, Layout, isPrivateRoute, access, rest });
  
  const location = useLocation();
  const sessionReducer = useSelector(({ session }: rootReducersState) => session);
  const currentUser = _.get(sessionReducer, "currentUser", {});
  const token = _.get(sessionReducer, "token", null);
  const messagingEnabled = isSessionMessagingEnabled(currentUser);
  const isMessagingRoute =
    location.pathname === appRoutes.candidateMessages.altPath ||
    location.pathname.startsWith(`${appRoutes.candidateMessages.altPath}/`) ||
    location.pathname === appRoutes.viewMessage.path;
  
  // Main conditional rendering logic - same structure as React Router v5
  if (isPrivateRoute === true) {
    if (token) {
      if (isMessagingRoute && !messagingEnabled) {
        return <Navigate to={getDefaultRoute()} replace />;
      }
      // Redirect User to the relevant pages
      // console.log("Private route - user authenticated, rendering with layout");
      return (
        <Layout>
          <Component {...rest} />
        </Layout>
      );
    } else {
      // redirect to login
      // console.log("Private route - user not authenticated, redirecting to login");
      return <Navigate to={appRoutes.userLogin.path} state={{ from: location }} replace />;
    }
  } else {
    // Check if user is already logged in
    if (token && [appRoutes.userLogin.path, appRoutes.userSignUp.path].includes(location.pathname)) {
      // console.log("User already logged in, redirecting to home");
      return <Navigate to="/" replace />;
    } else {
      // console.log("Public route - rendering with layout");
      return (
        <Layout>
          <Component {...rest} isPublic={true} />
        </Layout>
      );
    }
  }
};

export default RoutesContainer;